import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MeterSettingsService } from '../../services/meter-settings.service';
import { OrgSettings } from '../../models/meter-settings.model';

@Component({
    selector: 'app-meter-config',
    templateUrl: './meter-config.component.html',
    styleUrls: ['./meter-config.component.scss'],
})
export class MeterConfigComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    settings: OrgSettings | null = null;
    loading = false;
    saving = false;
    error = false;
    saveSuccess = false;
    notFound = false;

    pipeSizes: ('15-20mm' | '25-40mm' | '50-100mm')[] = ['15-20mm', '25-40mm', '50-100mm'];

    constructor(private settingsService: MeterSettingsService) {}

    ngOnInit(): void {
        this.loadSettings();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onSave(): void {
        if (!this.settings || this.saving) return;

        this.saving = true;
        this.saveSuccess = false;
        this.error = false;

        this.settingsService
            .saveSettings(this.settings)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (updated) => {
                    this.settings = updated;
                    this.saving = false;
                    this.saveSuccess = true;
                    setTimeout(() => (this.saveSuccess = false), 3000);
                },
                error: () => {
                    this.saving = false;
                    this.error = true;
                },
            });
    }

    private loadSettings(): void {
        this.loading = true;
        this.error = false;
        this.notFound = false;

        this.settingsService
            .getSettings()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (settings) => {
                    this.settings = settings;
                    this.loading = false;
                },
                error: (err) => {
                    this.loading = false;
                    if (err.status === 404) {
                        this.notFound = true;
                        this.settings = this.getDefaults();
                    } else {
                        this.error = true;
                    }
                },
            });
    }

    private getDefaults(): OrgSettings {
        return {
            billing: {
                waterFixedMonthly: { '15-20mm': 12.58, '25-40mm': 47.37, '50-100mm': 113.98 },
                sewerFixedMonthly: { '15-20mm': 42.19, '25-40mm': 54.77, '50-100mm': 133.22 },
                waterConsumptionMonthly: 27.8,
                sewerConsumptionMonthly: 14.8,
                waterAdditionalPerM3: 2.78,
                sewerAdditionalPerM3: 1.48,
                minMonthlyConsumptionM3: 10,
            },
            totalMeterAccounts: 1670,
            activeThresholdDays: 7,
            minDaysForProjection: 5,
        };
    }
}
